import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";

export type MessageCardTone = "default" | "info" | "warning" | "danger";

interface MessageCardProps {
  icon: LucideIcon;
  title: string;
  tone?: MessageCardTone;
  children: ReactNode;
  action?: ReactNode;
}

const TONE_CONTAINER: Record<MessageCardTone, string> = {
  default: "",
  info: "",
  warning: "",
  danger: "border-red-200 dark:border-red-800",
};

const TONE_ICON_TILE: Record<MessageCardTone, string> = {
  default: "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300",
  info: "bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400",
  warning:
    "bg-yellow-100 dark:bg-yellow-900 text-yellow-600 dark:text-yellow-400",
  danger: "bg-red-100 dark:bg-red-900 text-red-600 dark:text-red-400",
};

export default function MessageCard({
  icon: Icon,
  title,
  tone = "default",
  children,
  action,
}: MessageCardProps) {
  return (
    <div className={`card ${TONE_CONTAINER[tone]}`}>
      <div className="flex items-start gap-4">
        <div className={`rounded-full p-3 ${TONE_ICON_TILE[tone]}`}>
          <Icon className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {title}
          </h2>
          <div className="mt-1 text-sm text-gray-600 dark:text-gray-300">
            {children}
          </div>
          {action ? <div className="mt-4">{action}</div> : null}
        </div>
      </div>
    </div>
  );
}
